import React from "react";
import { useIconRepo } from "../../data/icons";
import { IconPackCard } from "./IconPackCard";
import { Typography } from "../ui/Typography";
import { shuffled } from "../../lib/util";

export const FeaturedIconPackGrid = (props: any) => {
    return (
        <section className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
            <Typography variant="h2" as="h2">
                Popular Packs
            </Typography>

            <FeaturedIconPack />
        </section>
    );
};

const FeaturedIconPack = (any) => {
    const repo = useIconRepo();

    // Don't render without icon data to show
    if (repo.loading || !repo.repository) {
        return null;
    }

    const subset = shuffled(repo.repository).slice(0, 8); // Or however many we want cos WE GOT PACKS ON PACKS

    return (
        <div className="relative">
            <div
                className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 
                 lg:gap-6 mx-auto sm:max-w-3xl xl:max-w-none"
            >
                {subset.map(pack => (<IconPackCard key={pack.name} packData={pack} />))}
            </div>
        </div>
    );
};























